import { kbbTheme } from '@argo/themes';
const {
  sm,
  md,
  lg,
  xl,
  max
} = kbbTheme.breakpoints;
export default {
  sm,
  md,
  lg,
  xl,
  max
};
//# sourceMappingURL=breakpoints.js.map